<template>
  <div>
    <div v-if="loading" class="ui-empty">
      <Spinner />
      <span>Загрузка продуктов…</span>
    </div>
    <p v-else-if="errorMessage" role="alert" class="ui-alert ui-alert--error">{{ errorMessage }}</p>
    <p v-else-if="products.length === 0" class="ui-empty">Продукты не найдены</p>
    <div v-else class="catalog-grid">
      <router-link
        v-for="product in products"
        :key="product.id"
        :to="{ name: 'product-detail', params: { id: product.id } }"
        class="catalog-product ui-panel"
      >
        <span class="catalog-icon">
          <img v-if="product.icon" :src="product.icon" :alt="product.name" />
          <Package v-else :size="26" />
        </span>
        <h2>{{ product.name }}</h2>
        <span class="catalog-open">
          Открыть карточку
          <ArrowUpRight :size="16" />
        </span>
      </router-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Spinner } from '@/components/ui/spinner';
import { Package, ArrowUpRight } from '@lucide/vue';

import { onMounted, ref } from 'vue';
import axios from 'axios';

const loading = ref(false);
const errorMessage = ref('');
const products = ref<Product[]>([]);

async function loadProducts() {
  loading.value = true;
  errorMessage.value = '';
  try {
    products.value = (await axios.get('/api/products/catalog/')).data as Product[];
  } catch (error) {
    console.error('Failed to load products catalog:', error);
    errorMessage.value = 'Не удалось загрузить каталог продуктов';
  } finally {
    loading.value = false;
  }
}

onMounted(async () => {
  await loadProducts();
});
</script>
